const React = require('react');


module.exports = (props) => {
  return (

    <svg
      viewBox="0 0 354.3 354.3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT path ' + (props.className || '')}
    >
      <g>
        <path
          d="M3.3,205.9l31-38.7L73,198.3l-8.9,11l-20.8-16.7c7.8,67.8,65.4,119.2,133.8,119.2c48.1,0,92.6-25.6,116.6-67.3l12.2,7 c-26.6,46-75.7,74.4-128.9,74.4c-75,0-138.4-55.9-147.7-130.2l-15.2,18.9L3.3,205.9z M155.2,127c-11.1,13.6-22.2,27.2-42.9,37.8 l47.6,36.9c21.6-9.5,33.4-23.5,45.1-37.4c11.4-13.5,22.7-27,42.2-37.2l-47.6-36.9C177.4,99.7,166.3,113.4,155.2,127z M144.2,118.1 C162.7,95.5,174,84.9,201.7,74l73.1,56.7c-29.3,11.6-38.4,18-59.1,42.7c-13.5,16.1-27.1,32.3-54.4,43l-3.7,1.5l-73.1-56.7 C114,149.5,123.7,143.2,144.2,118.1z M261,167.1c-9.3,3.7-17.1,12.8-26.4,23.8c-24.5,28.9-42.5,44.3-78.5,58.5l-63.3-49.1l8.6-11.2 l56.9,44.1c33.9-14.3,51.5-34.9,65.5-51.5c10.6-12.5,19.4-22.8,32-27.8L261,167.1z M261.1,200.7c-0.7,0.3-3.4,3.6-7.4,8.5 c-28.9,35.3-56.2,54.9-99.2,71.8l-63.3-49.1l8.6-11.2l56.9,44.1c49.9-20.6,73.5-49.4,86-64.6c5.4-6.6,9-11,13.2-12.7L261.1,200.7z M186.4,149.6l-6.9,7.4c2.7,1.1,7.2,2.3,9.8,0.6c2.1-1.3,1.4-4.6,0.8-6.5l13.3-4.8c3.1,8.5,1.6,18.1-6.5,23.2 c-8.4,5.3-19.3,2.9-27.4-1.8l-8.5,9.1l-10.4-9.6l8.1-8.8c-6.9-8.6-10.6-22.1-1.4-30.6c6-5.4,14.1-5.9,21.6-3.8l-3.9,13.6 c-2.1-0.6-5.6-1.1-7.6,0.2c-3.1,2.3-0.5,7.6,1.1,10.1l7.4-8L186.4,149.6z M351,148.4L320,187.1L281.3,156l8.9-11l20.8,16.7 c-7.8-67.8-65.4-119.2-133.8-119.2c-48.1,0-92.6,25.6-116.6,67.3l-12.2-7c26.6-46,75.7-74.4,128.9-74.4 c75,0,138.4,55.9,147.7,130.2l15.2-18.9L351,148.4z"/>
      </g>
    </svg>
  );
};
